import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[AEGIS UI ErrorBoundary caught error]:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="p-6 m-4 bg-red-950/60 border border-red-500/40 rounded-lg backdrop-blur-md text-red-200">
          <div className="flex items-center gap-3 mb-2">
            <span className="text-xl">⚠️</span>
            <h3 className="text-red-400 font-semibold text-base">组件渲染异常 (Component Render Failure)</h3>
          </div>
          <p className="text-sm font-mono bg-red-900/40 p-3 rounded border border-red-800/50 text-red-300 overflow-x-auto my-3">
            {this.state.error?.message || '未知前端渲染错误'}
          </p>
          <div className="flex gap-3">
            <button
              onClick={() => this.setState({ hasError: false, error: null })}
              className="px-4 py-1.5 bg-red-800 hover:bg-red-700 text-white rounded text-xs font-mono transition-colors"
            >
              重试 (Retry)
            </button>
            <button
              onClick={() => window.location.reload()}
              className="px-4 py-1.5 bg-slate-800 hover:bg-slate-700 text-slate-300 rounded text-xs font-mono transition-colors"
            >
              刷新页面 (Reload Page)
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
